module.exports = __webpack_public_path__ + "img/rule-draft.9c2c7fc2.svg";